import { useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { Check } from "./preparation-types";
export function usePreparationRecheckWorkspace({ check, notify, onSaved, }: {
    check: Check;
    notify: (message: string) => void;
    onSaved: (check: Check) => void;
}) {
    const [loading, setLoading] = useState(false);
    const run = async () => {
        setLoading(true);
        try {
            const next = await apiRequest<Check>("/api/material-preparation/checks", {
                method: "POST",
                body: JSON.stringify({
                    runId: check.runId,
                    forceRevision: true,
                    onlyIfSourceChanged: true,
                }),
            });
            onSaved(next);
            notify(next.id === check.id && next.revision === check.revision
                ? "Mikro reçete ve depo stokları yeniden okundu; kaynak veride değişiklik bulunmadığı için mevcut kontrol korundu."
                : `Mikro reçete veya stok verisi değişti; kontrol revizyonu ${next.revision} oluşturuldu.`);
        }
        catch (error) {
            notify(error instanceof Error
                ? error.message
                : "Mikro yeniden kontrolü tamamlanamadı.");
        }
        finally {
            setLoading(false);
        }
    };
    return { loading, run };
}
